const CardExpertise = ({ title, cta, imageShape, image, colorScheme }) => {

  return {
    title,
    href: cta?.href,
    imageShape,
    image,
    colorScheme
  }
}

export default CardExpertise